import { Text, Badge, tokens } from '@hotjar/hotsauce';
import { ProductType } from '@hotjar/webapp/domains/common/product/types';
import { useTranslationWithPrefix } from '@hotjar/translations';

export const SecondaryText = ({
  isLowerTier,
  isRecommendedPlan,
  isCurrentProduct,
  productType,
}: {
  isLowerTier: boolean;
  isRecommendedPlan: boolean;
  isCurrentProduct: boolean;
  productType: ProductType;
}): JSX.Element => {
  const { t } = useTranslationWithPrefix('billing:plan-select-upsell-modal.plan-select');

  if (isLowerTier) {
    return (
      <Text style={{ color: 'inherit' }} textType="subtitle3">
        {productType === ProductType.Analytics
          ? t('reduced-daily-sessions')
          : t('reduced-monthly-responses')}
      </Text>
    );
  }

  if (isCurrentProduct) {
    return (
      <Badge
        kind="custom"
        size="s"
        color={tokens.color.ui_disabled}
        textColor={tokens.color.text_light}
      >
        {t('current-plan')}
      </Badge>
    );
  }

  if (isRecommendedPlan) {
    return (
      <Text style={{ color: tokens.color.primary_cta }} textType="subtitle3">
        {t('recommended')}
      </Text>
    );
  }

  return <div style={{ height: tokens.spacer.x2pt5 }} />;
};
